import styled from 'styled-components'
import {colors} from "../../styles/colors";

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .photo-input {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 5rem;
    
        .cross-button {
            margin-top: 2rem;
            transform: translateX(-50%);
    
            svg {
                width: 2rem;
                height: 2rem;
            }
        }
        input {
            display: none;
        }
    }
    .input-description, p {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 2rem;
        line-height: 160%;
        color: ${colors.white};
        margin-bottom: 1rem;
    }
    .input {
        width: 100%;
        height: 55px;
        color: ${colors.dark_blue};
    
        padding-left: 2.5rem; 
    
        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;
    
        outline: none;
    
        :not(:last-child) {
            margin-bottom: 3.75rem;
        }
    
        ::placeholder {
            font-family: 'SF UI Text',sans-serif;
            font-weight: 300;
            font-size: 2.5rem;
            line-height: 150%;    
            color: ${colors.dark_blue};
        }
    
        @media (max-width: 767.98px) {
            margin-bottom: 3.75rem;
        }
    }
    .select {
        width: 100%;
        height: 55px;
        color: ${colors.dark_blue};
    
        padding-left: 2.5rem; 
    
        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 150%;
    
        outline: none;
        margin-bottom: 3.75rem;
    }
    .submit-button {
        display: inline-block;
        width: auto;
        margin: 5rem auto 0 auto;
    }
    .link-button {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 2rem;
        line-height: 160%;
        color: ${colors.white};
        margin-top: 2rem;
    
        :hover {
            cursor: pointer;
            text-decoration: underline; 
        }
    }
    .delete-button:hover {
      color: ${colors.red};
    }
    .preloader {
        margin-top: 3rem;
    }
`
export const CategoriesSettingsContainer = styled.div`
    width: 100%;
    height: 100%;
    overflow: auto;
    
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    background: rgba(255, 255, 255, 0.5);
    
    padding: 2rem;
    
    // INCLUDED CLASSES:
    
    .popup-box {
        margin: 5rem auto;
    }
    .title {
        max-width: 500px;
        font-family: 'SF UI Text',sans-serif;
        font-weight: 400;
        font-size: 3.75rem;
        line-height: 160%;
        color: ${colors.white};
        margin-bottom: 3.75rem;
    }
    .choose-button {
        margin-bottom: 3rem;
    }

`
